
export function getNextQuestion(seq, from, max) {

  if (!seq)
    return from;

  let n = from + 1;

  while (n <= (max || from)) {
    const step = seq[n];
    if (!step)
      return from;
    if (step.skip || step.response?.skip) {
      n++;
      continue;
    }
    return n;
  }
  return from;
}
